import { useState } from "react";
import { Link } from "react-router-dom";
import { FaFacebookF, FaTwitter, FaInstagram } from "react-icons/fa";
import axios from "../api/axiosInstance";

const FacebookIcon = FaFacebookF as unknown as React.FC;
const TwitterIcon = FaTwitter as unknown as React.FC;
const InstagramIcon = FaInstagram as unknown as React.FC;

interface NewsletterResponse {
    message: string;
}

const Footer = () => {
    const [email, setEmail] = useState("");
    const [message, setMessage] = useState("");

    const handleSubscribe = async () => {
        if (!email) return setMessage("Please enter a valid email.");

        try {
            const res = await axios.post<NewsletterResponse>("/newsletter/subscribe", { email });
            setMessage(res.data.message || "Successfully subscribed!");
            setEmail("");
        } catch (error: any) {
            setMessage(error.response?.data?.error || "Subscription failed.");
        }
    };
    return (
        <footer className="bg-gray-900 text-white w-full">
            <div className="max-w-7xl mx-auto px-6 pt-12 pb-6 grid grid-cols-1 md:grid-cols-4 gap-10">
                <div>
                    <h2 className="text-2xl font-bold text-white mb-2">SavoryBot</h2>
                    <p className="text-gray-400 text-sm">
                        AI-powered recommendations for smarter restaurant engagement.
                    </p>
                    <div className="flex space-x-4 mt-4">
                        <a href="#" className="text-gray-400 hover:text-white transition"><FacebookIcon /></a>
                        <a href="#" className="text-gray-400 hover:text-white transition"><TwitterIcon /></a>
                        <a href="#" className="text-gray-400 hover:text-white transition"><InstagramIcon /></a>
                    </div>
                </div>
                <div>
                    <h4 className="text-lg font-semibold mb-3">Explore</h4>
                    <ul className="space-y-2 text-gray-300 text-sm">
                        <li><Link to="/" className="hover:text-white transition">Home</Link></li>
                        <li><Link to="/pricing" className="hover:text-white transition">Pricing</Link></li>
                        <li><Link to="/contact" className="hover:text-white transition">Contact</Link></li>
                        <li><Link to="/login" className="hover:text-white transition">Login</Link></li>
                    </ul>
                </div>
                <div>
                    <h4 className="text-lg font-semibold mb-3">Contact Us</h4>
                    <p className="text-gray-400 text-sm">sales@savoryai.io</p>
                </div>
                <div>
                    <h4 className="text-lg font-semibold mb-3">Stay Updated</h4>
                    <p className="text-gray-400 text-sm mb-2">Join our newsletter for product updates.</p>
                    <input
                        type="email"
                        placeholder="Your email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                        className="w-full px-3 py-2 rounded bg-gray-800 text-sm text-white placeholder-gray-400 focus:outline-none"
                    />
                    <button
                        onClick={handleSubscribe}
                        className="mt-2 w-full bg-blue-600 hover:bg-blue-700 text-white text-sm py-2 px-4 rounded transition"
                    >
                        Subscribe
                    </button>
                    {message && (
                        <p className="text-xs mt-2 text-center text-green-400">{message}</p>
                    )}
                </div>
            </div>
            <div className="text-center text-sm text-gray-500 mt-12 border-t border-gray-700 pt-4 w-full">
                &copy; {new Date().getFullYear()} SavoryBot. All rights reserved.
            </div>
        </footer>
    );
};

export default Footer;
